import React from "react";
import ReplayIcon from '@mui/icons-material/Replay';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}
/*
  NOTE: Funktioniert, aber als "dev" sieht man trotzdem die Riesige Rote Fehlermeldung von React
*/
class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
    state = { hasError: false, errorMessage: '' };
  
    static getDerivedStateFromError(error: Error) {
      // Update state to render fallback UI
      return { hasError: true, errorMessage: error.message };
    }
  
    componentDidCatch(error: Error) {
      console.error("Error caught by ErrorBoundary:", error);
    }
  
    render() {
      if (this.state.hasError) {
        return (
            <div className="error-container">
                <h1>Ein Fehler ist aufgetreten.</h1>
                <p className="error-message">{this.state.errorMessage}</p>
                <button onClick={() => window.location.reload()}><ReplayIcon />Reload</button>
            </div>
        );
      }
  
      return this.props.children;
    }
  }
  
  export default ErrorBoundary;